import {
  AppContext,
  Box,
  Button,
  Dialog,
  FiltersController,
  IPredicate,
  TFilter,
  useSyncFilterValue,
  userEffectorModel,
} from '@centra/centra-ui/dist'
import React, { Dispatch, FC, SetStateAction, useContext, useRef, useState } from 'react'
import { SingleModalFilter } from './SingleModalFilter/SingleModalFilter'
import { mapTaskFilter } from '../utils'
import { getTaskFilters } from '../filters'
import { useStore } from 'effector-react'
import { sortPinnedFilters } from './utils'
import { isEqual } from 'lodash'

import styled from './AllFiltersModal.module.scss'
import { PINNED_FILTERS } from '../consts'

interface IAllFilterModalProps {
  open: boolean
  setOpenFilterModal: Dispatch<SetStateAction<boolean>>
  controller: FiltersController
  filterScheme: Map<string, TFilter>
  query: string
  setPinnedFilters: Dispatch<SetStateAction<string | null>>
  pinnedFilters: string | null
}

export const AllFiltersModal: FC<IAllFilterModalProps> = ({
  open,
  setOpenFilterModal,
  controller,
  filterScheme,
  query,
  setPinnedFilters,
  pinnedFilters,
}) => {
  const { ngApiClient } = useContext(AppContext)
  const userStore = useStore(userEffectorModel.$userStore)
  const [newPinnedfilters, setNewPinnedFilters] = useState(pinnedFilters)
  const predicates = useSyncFilterValue({
    controller,
  })

  const filterModalController = useRef(
    new FiltersController({
      scheme: mapTaskFilter(getTaskFilters({ httpClient: ngApiClient }), userStore?.tags),
      ngApiClient,
      predicates: predicates as IPredicate[],
    })
  )
  const predicatesNew = useSyncFilterValue({
    controller: filterModalController.current,
  })
  const isDisabled = isEqual(predicates, predicatesNew) && newPinnedfilters === pinnedFilters

  const handleSubmit = () => {
    controller.updateDefaultValues(predicatesNew)
    setOpenFilterModal(false)
    filterModalController.current.onResetList(true)
    if (newPinnedfilters) {
      setPinnedFilters(newPinnedfilters)
      localStorage.setItem(PINNED_FILTERS, newPinnedfilters)
    }
  }

  const handleClearAll = () => {
    filterModalController.current.onResetList(true)
  }

  const handleClose = () => {
    setOpenFilterModal(false)
    setPinnedFilters(localStorage.getItem(PINNED_FILTERS))
  }

  return (
    <Dialog id="allFiltersDialog" open={open} onClose={handleClose} className={styled.container}>
      <Dialog.Header content="Все фильтры" />
      <Box column gap={24} alignItems={'center'} paddingTop={24} paddingBottom={32}>
        {Array.from(filterScheme)
          .sort((a, b) => sortPinnedFilters(a, b, newPinnedfilters))
          .map(f => (
            <SingleModalFilter
              pinnedFilters={newPinnedfilters}
              setNewPinnedFilters={setNewPinnedFilters}
              key={f[0]}
              filterLabel={f[1].title}
              controller={filterModalController.current}
              filterName={f[0]}
              query={query}
            />
          ))}
      </Box>
      <Box justifyContent={'spaceBetween'} paddingRight={64} paddingTop={4}>
        <Button id="submitFiltersBtn" size="lg" onClick={handleSubmit} disabled={isDisabled}>
          Применить
        </Button>
        <Box gap={4}>
          <Button id="clearAllFiltersBtn" size="lg" view="textLight" onClick={handleClearAll}>
            Очистить все
          </Button>
          <Button id="cancelFiltersBtn" size="lg" view="textLight" onClick={handleClose}>
            Отмена
          </Button>
        </Box>
      </Box>
    </Dialog>
  )
}
